import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook que envia pageview ao Google Analytics em cada navegação SPA.
 * O GA no index.html é configurado com send_page_view: false,
 * então só este hook dispara os page_view events.
 */
export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
}
